<template>
  <b-modal id="licenseModal" :title="'license_info' | i18n" button-size="sm" content-class="rounded-8" centered hide-footer>
    <div v-if="license">
      <p>
        <label>{{ 'licensed_for' | i18n }}:</label> {{ license.ownerCompanyName }}
      </p>
      <p>
        <label>{{ 'license_version' | i18n }}:</label> {{ license.version }}
      </p>
      <p>
        <label>{{ 'license_valid_until' | i18n }}:</label> {{ license.validUntil | formatDate('DD.MM.YYYY') }}
      </p>
      <p>
        <label>{{ 'Licenced modules' | i18n }}:</label> {{ license.modules.join(', ').toUpperCase() }}
      </p>
      <p>
        <label>{{ 'license_number_of_devices' | i18n }}:</label> {{ license.numberOfDevices }}
      </p>
      <p>
        <label>{{ 'client_id' | i18n }}:</label> {{ license.id.slice(0, 8) }}...
      </p>
      <p class="reloadWrapper">
        <b-button variant="outline-primary" size="sm" class="btn-delete-device" @click="clickUpdateLicense">
          {{ 'reload_license_information' | i18n }}
        </b-button>
      </p>
      <p class="reloadWrapper">
        <b-button v-b-modal.modalPopover variant="outline-primary" size="sm" class="btn-delete-device" @click="showUpdateModal">
          {{ 'Update Data Server' | i18n }}
        </b-button>
      </p>
    </div>
  </b-modal>
</template>
<script>
import { LicenseMixin, NotificationMixin } from '../../mixins';

export default {
  name: 'LicenseInfo',
  mixins: [LicenseMixin, NotificationMixin],
  data: function () {
    return {
      seconds: 5,
    };
  },
  methods: {
    showUpdateModal() {
      this.$root.$emit('bv::hide::modal', 'licenseModal');
      this.$root.$emit('bv::show::modal', 'updateModal');
    },
    async clickUpdateLicense() {
      try {
        await this.loadLicense(true);
        this.showNotification({
          type: 'success',
          title: this.$translate('update_licence_success'),
          message: this.$translate('The page will be refresh in 5 seconds'),
        });
        setInterval(() => {
          this.seconds -= 1;
          if (this.seconds === 0) {
            window.location.reload(true);
          }
        }, 1000);
      } catch (e) {
        this.showNotification({ type: 'error', title: this.$translate('update_licence'), message: this.$translate('update_licence_error') });
      }
    },
  },
};
</script>

<style scoped>
.reloadWrapper {
  display: flex;
  justify-content: center;
}
label {
  color: #7586a5;
}
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px !important;
}
::v-deep .rounded-8 {
  border-radius: 8px;
}
</style>
